module.exports = __webpack_public_path__ + "static/votingwhileblack-7ef8a041952765e8c6513bd8e5b00320.png";